import { ref as y, onMounted as R, computed as v, defineComponent as I, watch as te, onUnmounted as ue, nextTick as de, toRef as _e } from "vue";
import { FileType as V, formatFileSize as fe, davGetClient as pe, davResultToNode as M, davRootPath as D, getFavoriteNodes as ve, davGetRecentSearch as me, davGetDefaultPropfind as ge } from "@nextcloud/files";
import { getCanonicalLocale as he } from "@nextcloud/l10n";
import { NcCheckboxRadioSwitch as ie, NcDateTime as ye, NcButton as ne, NcActions as we, NcActionInput as Ce, NcBreadcrumbs as be, NcBreadcrumb as ke, NcSelect as Fe, NcTextField as Se, NcDialog as $e, NcEmptyContent as xe } from "@nextcloud/vue";
import { join as le } from "path";
import { loadState as se } from "@nextcloud/initial-state";
import { generateUrl as H } from "@nextcloud/router";
import { toValue as ee } from "@vueuse/core";
import re from "@nextcloud/axios";
import { t as w, k as Ne } from "./toast-d1cd63b1.mjs";
import { Fragment as Pe } from "vue-frag";
import { emit as Le } from "@nextcloud/event-bus";
function k(s, e, i, t, n, l, o, _) {
  var r = typeof s == "function" ? s.options : s;
  e && (r.render = e, r.staticRenderFns = i, r._compiled = !0), t && (r.functional = !0), l && (r._scopeId = "data-v-" + l);
  var u;
  if (o ? (u = function(f) {
    f = f || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !f && typeof __VUE_SSR_CONTEXT__ < "u" && (f = __VUE_SSR_CONTEXT__), n && n.call(this, f), f && f._registeredComponents && f._registeredComponents.add(o);
  }, r._ssrRegister = u) : n && (u = _ ? function() {
    n.call(
      this,
      (r.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : n), u)
    if (r.functional) {
      r._injectStyles = u;
      var p = r.render;
      r.render = function(g, d) {
        return u.call(d), p(g, d);
      };
    } else {
      var C = r.beforeCreate;
      r.beforeCreate = C ? [].concat(C, u) : [u];
    }
  return {
    exports: s,
    options: r
  };
}
const ze = {
  name: "FileIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Be = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon file-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M13,9V3.5L18.5,9M6,2C4.89,2 4,2.89 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2H6Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, Ie = [], Ve = /* @__PURE__ */ k(
  ze,
  Be,
  Ie,
  !1,
  null,
  null,
  null,
  null
);
const ae = Ve.exports;
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
const oe = () => {
  var s, e, i;
  const t = se("files", "config", null), n = y((s = t == null ? void 0 : t.show_hidden) != null ? s : !1), l = y((e = t == null ? void 0 : t.sort_favorites_first) != null ? e : !0), o = y((i = t == null ? void 0 : t.crop_image_previews) != null ? i : !0);
  return R(() => {
    re.get(H("/apps/files/api/v1/configs")).then((_) => {
      var r, u, p, C, f, g, d, S, $;
      n.value = (p = (u = (r = _.data) == null ? void 0 : r.data) == null ? void 0 : u.show_hidden) != null ? p : !1, l.value = (g = (f = (C = _.data) == null ? void 0 : C.data) == null ? void 0 : f.sort_favorites_first) != null ? g : !0, o.value = ($ = (S = (d = _.data) == null ? void 0 : d.data) == null ? void 0 : S.crop_image_previews) != null ? $ : !0;
    });
  }), {
    showHiddenFiles: n,
    sortFavoritesFirst: l,
    cropImagePreviews: o
  };
}, Re = (s) => {
  var e, i, t, n, l, o, _, r, u, p, C, f;
  const g = (b) => b === "asc" ? "ascending" : b === "desc" ? "descending" : "none", d = se("files", "viewConfigs", null), S = y({
    sortBy: (i = (e = d == null ? void 0 : d.files) == null ? void 0 : e.sorting_mode) != null ? i : "basename",
    order: g((n = (t = d == null ? void 0 : d.files) == null ? void 0 : t.sorting_direction) != null ? n : "asc")
  }), $ = y({
    sortBy: (o = (l = d == null ? void 0 : d.recent) == null ? void 0 : l.sorting_mode) != null ? o : "basename",
    order: g((r = (_ = d == null ? void 0 : d.recent) == null ? void 0 : _.sorting_direction) != null ? r : "asc")
  }), P = y({
    sortBy: (p = (u = d == null ? void 0 : d.favorites) == null ? void 0 : u.sorting_mode) != null ? p : "basename",
    order: g((f = (C = d == null ? void 0 : d.favorites) == null ? void 0 : C.sorting_direction) != null ? f : "asc")
  });
  R(() => {
    re.get(H("/apps/files/api/v1/views")).then((b) => {
      var h, a, c, F, x, z, B, T, E, U, Z, O, j, G, W, q, K, X, J, Q, Y;
      S.value = {
        sortBy: (F = (c = (a = (h = b.data) == null ? void 0 : h.data) == null ? void 0 : a.files) == null ? void 0 : c.sorting_mode) != null ? F : "basename",
        order: g((B = (z = (x = b.data) == null ? void 0 : x.data) == null ? void 0 : z.files) == null ? void 0 : B.sorting_direction)
      }, P.value = {
        sortBy: (Z = (U = (E = (T = b.data) == null ? void 0 : T.data) == null ? void 0 : E.favorites) == null ? void 0 : U.sorting_mode) != null ? Z : "basename",
        order: g((G = (j = (O = b.data) == null ? void 0 : O.data) == null ? void 0 : j.favorites) == null ? void 0 : G.sorting_direction)
      }, $.value = {
        sortBy: (X = (K = (q = (W = b.data) == null ? void 0 : W.data) == null ? void 0 : q.recent) == null ? void 0 : K.sorting_mode) != null ? X : "basename",
        order: g((Y = (Q = (J = b.data) == null ? void 0 : J.data) == null ? void 0 : Q.recent) == null ? void 0 : Y.sorting_direction)
      };
    });
  });
  const N = v(() => ee(s || "files") === "files" ? S.value : ee(s) === "recent" ? $.value : P.value), L = v(() => N.value.sortBy), m = v(() => N.value.order);
  return {
    filesViewConfig: S,
    favoritesViewConfig: P,
    recentViewConfig: $,
    currentConfig: N,
    sortBy: L,
    order: m
  };
}, Me = {
  name: "MenuUpIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var De = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon menu-up-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M7,15L12,10L17,15H7Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, He = [], Ae = /* @__PURE__ */ k(
  Me,
  De,
  He,
  !1,
  null,
  null,
  null,
  null
);
const Te = Ae.exports, Ee = {
  name: "MenuDownIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Ue = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon menu-down-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M7,10L12,15L17,10H7Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, Ze = [], Oe = /* @__PURE__ */ k(
  Ee,
  Ue,
  Ze,
  !1,
  null,
  null,
  null,
  null
);
const je = Oe.exports, ce = {
  "file-picker__file-icon": "_file-picker__file-icon_1vgv4_5"
}, Ge = /* @__PURE__ */ I({
  __name: "LoadingTableRow",
  props: {
    showCheckbox: { type: Boolean }
  },
  setup(s) {
    return { __sfc: !0, fileListIconStyles: ce };
  }
});
var We = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i("tr", { staticClass: "file-picker__row loading-row", attrs: { "aria-hidden": "true" } }, [e.showCheckbox ? i("td", { staticClass: "row-checkbox" }, [i("span")]) : e._e(), i("td", { staticClass: "row-name" }, [i("div", { staticClass: "row-wrapper" }, [i("span", { class: t.fileListIconStyles["file-picker__file-icon"] }), i("span")])]), e._m(0), e._m(1)]);
}, qe = [function() {
  var s = this, e = s._self._c;
  return s._self._setupProxy, e("td", { staticClass: "row-size" }, [e("span")]);
}, function() {
  var s = this, e = s._self._c;
  return s._self._setupProxy, e("td", { staticClass: "row-modified" }, [e("span")]);
}], Ke = /* @__PURE__ */ k(
  Ge,
  We,
  qe,
  !1,
  null,
  "6aded0d9",
  null,
  null
);
const Xe = Ke.exports;
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 */
function Je(s, e = {}) {
  var i;
  e = { size: 32, cropPreview: !1, mimeFallback: !0, ...e };
  try {
    const t = ((i = s.attributes) == null ? void 0 : i.previewUrl) || H("/core/preview?fileId={fileid}", {
      fileid: s.fileid
    });
    let n;
    try {
      n = new URL(t);
    } catch {
      n = new URL(t, window.location.origin);
    }
    return n.searchParams.set("x", "".concat(e.size)), n.searchParams.set("y", "".concat(e.size)), n.searchParams.set("mimeFallback", "".concat(e.mimeFallback)), n.searchParams.set("a", e.cropPreview === !0 ? "0" : "1"), n.searchParams.set("c", "".concat(s.attributes.etag)), n;
  } catch {
    return null;
  }
}
const Qe = {
  name: "FolderIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Ye = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon folder-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M10,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V8C22,6.89 21.1,6 20,6H12L10,4Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, et = [], tt = /* @__PURE__ */ k(
  Qe,
  Ye,
  et,
  !1,
  null,
  null,
  null,
  null
);
const A = tt.exports, it = {
  name: "FilePreview"
}, nt = /* @__PURE__ */ I({
  ...it,
  props: {
    node: null,
    cropImagePreviews: { type: Boolean }
  },
  setup(s) {
    const e = s, i = y(ce), t = v(() => Je(e.node, { cropPreview: e.cropImagePreviews })), n = v(() => e.node.type === V.File), l = y(!1);
    return te(t, () => {
      if (l.value = !1, t.value) {
        const o = document.createElement("img");
        o.src = t.value.href, o.onerror = () => o.remove(), o.onload = () => {
          l.value = !0, o.remove();
        }, document.body.appendChild(o);
      }
    }, { immediate: !0 }), { __sfc: !0, fileListIconStyles: i, props: e, previewURL: t, isFile: n, canLoadPreview: l, t: w, IconFile: ae, IconFolder: A };
  }
});
var lt = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i("div", { class: t.fileListIconStyles["file-picker__file-icon"], style: t.canLoadPreview ? { backgroundImage: "url(".concat(t.previewURL, ")") } : void 0, attrs: { "aria-label": t.t("MIME type {mime}", { mime: e.node.mime || t.t("unknown") }) } }, [t.canLoadPreview ? e._e() : [t.isFile ? i(t.IconFile, { attrs: { size: 20 } }) : i(t.IconFolder, { attrs: { size: 20 } })]], 2);
}, st = [], rt = /* @__PURE__ */ k(
  nt,
  lt,
  st,
  !1,
  null,
  null,
  null,
  null
);
const at = rt.exports, ot = /* @__PURE__ */ I({
  __name: "FileListRow",
  props: {
    allowPickDirectory: { type: Boolean },
    selected: { type: Boolean },
    showCheckbox: { type: Boolean },
    canPick: { type: Boolean },
    node: null,
    cropImagePreviews: { type: Boolean }
  },
  emits: ["update:selected", "enter-directory"],
  setup(s, { emit: e }) {
    const i = s, t = v(() => {
      var p;
      return ((p = i.node.attributes) == null ? void 0 : p.displayName) || i.node.basename.slice(0, i.node.extension ? -i.node.extension.length : void 0);
    }), n = v(() => i.node.extension), l = v(() => i.node.type === V.Folder), o = v(() => i.canPick && (i.allowPickDirectory || !l.value));
    function _() {
      e("update:selected", !i.selected);
    }
    function r() {
      l.value ? e("enter-directory", i.node) : _();
    }
    function u(p) {
      p.key === "Enter" && r();
    }
    return { __sfc: !0, props: i, emit: e, displayName: t, fileExtension: n, isDirectory: l, isPickable: o, toggleSelected: _, handleClick: r, handleKeyDown: u, formatFileSize: fe, NcCheckboxRadioSwitch: ie, NcDateTime: ye, t: w, FilePreview: at };
  }
});
var ct = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i("tr", e._g(
    { class: ["file-picker__row", {
      "file-picker__row--selected": e.selected && !e.showCheckbox
    }], attrs: { tabindex: e.showCheckbox && !t.isDirectory ? void 0 : 0, "aria-selected": t.isPickable ? e.selected : void 0, "data-filename": e.node.basename, "data-testid": "file-list-row" }, on: { click: t.handleClick } },
    /* same as tabindex -> if we hide the checkbox or this is a directory we need keyboard access to enter the directory or select the node */
    !e.showCheckbox || t.isDirectory ? { keydown: t.handleKeyDown } : {}
  ), [e.showCheckbox ? i("td", { staticClass: "row-checkbox" }, [i(t.NcCheckboxRadioSwitch, { attrs: { disabled: !t.isPickable, checked: e.selected, "aria-label": t.t("Select the row for {nodename}", { nodename: t.displayName }), "data-testid": "row-checkbox" }, on: { click: function(n) {
    n.stopPropagation();
  }, "update:checked": t.toggleSelected } })], 1) : e._e(), i("td", { staticClass: "row-name" }, [i("div", { staticClass: "file-picker__name-container", attrs: { "data-testid": "row-name" } }, [i(t.FilePreview, { attrs: { node: e.node, "crop-image-previews": e.cropImagePreviews } }), i("div", { staticClass: "file-picker__file-name", attrs: { title: t.displayName }, domProps: { textContent: e._s(t.displayName) } }), i("div", { staticClass: "file-picker__file-extension", domProps: { textContent: e._s(t.fileExtension) } })], 1)]), i("td", { staticClass: "row-size" }, [e._v(" " + e._s(t.formatFileSize(e.node.size || 0)) + " ")]), i("td", { staticClass: "row-modified" }, [i(t.NcDateTime, { attrs: { timestamp: e.node.mtime, "ignore-seconds": !0 } })], 1)]);
}, ut = [], dt = /* @__PURE__ */ k(
  ot,
  ct,
  ut,
  !1,
  null,
  "ee6f34b5",
  null,
  null
);
const _t = dt.exports, ft = /* @__PURE__ */ I({
  __name: "FileList",
  props: {
    currentView: null,
    multiselect: { type: Boolean },
    allowPickDirectory: { type: Boolean },
    loading: { type: Boolean },
    files: null,
    selectedFiles: null,
    path: null
  },
  emits: ["update:path", "update:selectedFiles"],
  setup(s, { emit: e }) {
    const i = s, t = y(), { currentConfig: n } = Re(i.currentView), l = v(() => {
      var m;
      return (m = t.value) != null ? m : n.value;
    }), o = v(() => l.value.sortBy === "basename" ? l.value.order === "none" ? void 0 : l.value.order : void 0), _ = v(() => l.value.sortBy === "size" ? l.value.order === "none" ? void 0 : l.value.order : void 0), r = v(() => l.value.sortBy === "mtime" ? l.value.order === "none" ? void 0 : l.value.order : void 0), u = (m) => {
      l.value.sortBy === m ? l.value.order === "ascending" ? t.value = { sortBy: l.value.sortBy, order: "descending" } : t.value = { sortBy: l.value.sortBy, order: "ascending" } : t.value = { sortBy: m, order: "ascending" };
    }, { sortFavoritesFirst: p, cropImagePreviews: C } = oe(), f = v(
      () => {
        const m = {
          ascending: (h, a, c) => c(h, a),
          descending: (h, a, c) => c(a, h),
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          none: (h, a, c) => 0
        }, b = {
          basename: (h, a) => {
            var c, F;
            return (((c = h.attributes) == null ? void 0 : c.displayName) || h.basename).localeCompare(((F = a.attributes) == null ? void 0 : F.displayName) || a.basename, he());
          },
          size: (h, a) => (h.size || 0) - (a.size || 0),
          // reverted because "young" is smaller than "old"
          mtime: (h, a) => {
            var c, F, x, z;
            return (((F = (c = a.mtime) == null ? void 0 : c.getTime) == null ? void 0 : F.call(c)) || 0) - (((z = (x = h.mtime) == null ? void 0 : x.getTime) == null ? void 0 : z.call(x)) || 0);
          }
        };
        return [...i.files].sort(
          (h, a) => (
            // Folders always come above the files
            (a.type === V.Folder ? 1 : 0) - (h.type === V.Folder ? 1 : 0) || (p ? (a.attributes.favorite ? 1 : 0) - (h.attributes.favorite ? 1 : 0) : 0) || m[l.value.order](h, a, b[l.value.sortBy])
          )
        );
      }
    ), g = v(() => i.files.filter((m) => i.allowPickDirectory || m.type !== V.Folder)), d = v(() => !i.loading && i.selectedFiles.length > 0 && i.selectedFiles.length >= g.value.length);
    function S() {
      i.selectedFiles.length < g.value.length ? e("update:selectedFiles", g.value) : e("update:selectedFiles", []);
    }
    function $(m) {
      i.selectedFiles.includes(m) ? e("update:selectedFiles", i.selectedFiles.filter((b) => b.path !== m.path)) : i.multiselect ? e("update:selectedFiles", [...i.selectedFiles, m]) : e("update:selectedFiles", [m]);
    }
    function P(m) {
      e("update:path", le(i.path, m.basename));
    }
    const N = y(4), L = y();
    {
      const m = () => de(() => {
        var b, h, a, c, F;
        const x = ((h = (b = L.value) == null ? void 0 : b.parentElement) == null ? void 0 : h.children) || [];
        let z = ((c = (a = L.value) == null ? void 0 : a.parentElement) == null ? void 0 : c.clientHeight) || 450;
        for (let B = 0; B < x.length; B++)
          (F = L.value) != null && F.isSameNode(x[B]) || (z -= x[B].clientHeight);
        N.value = Math.floor((z - 50) / 50);
      });
      R(() => {
        window.addEventListener("resize", m), m();
      }), ue(() => {
        window.removeEventListener("resize", m);
      });
    }
    return { __sfc: !0, props: i, emit: e, customSortingConfig: t, filesAppSorting: n, sortingConfig: l, sortByName: o, sortBySize: _, sortByModified: r, toggleSorting: u, sortFavoritesFirst: p, cropImagePreviews: C, sortedFiles: f, selectableFiles: g, allSelected: d, onSelectAll: S, onNodeSelected: $, onChangeDirectory: P, skeletonNumber: N, fileContainer: L, NcButton: ne, NcCheckboxRadioSwitch: ie, t: w, IconSortAscending: Te, IconSortDescending: je, LoadingTableRow: Xe, FileListRow: _t };
  }
});
var pt = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i("div", { ref: "fileContainer", staticClass: "file-picker__files" }, [i("table", [i("thead", [i("tr", [e.multiselect ? i("th", { staticClass: "row-checkbox" }, [i("span", { staticClass: "hidden-visually" }, [e._v(" " + e._s(t.t("Select entry")) + " ")]), e.multiselect ? i(t.NcCheckboxRadioSwitch, { attrs: { "aria-label": t.t("Select all entries"), checked: t.allSelected, "data-testid": "select-all-checkbox" }, on: { "update:checked": t.onSelectAll } }) : e._e()], 1) : e._e(), i("th", { staticClass: "row-name", attrs: { "aria-sort": t.sortByName } }, [i("div", { staticClass: "header-wrapper" }, [i("span", { staticClass: "file-picker__header-preview" }), i(t.NcButton, { attrs: { wide: !0, type: "tertiary", "data-test": "file-picker_sort-name" }, on: { click: function(n) {
    return t.toggleSorting("basename");
  } }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t.sortByName === "ascending" ? i(t.IconSortAscending, { attrs: { size: 20 } }) : t.sortByName === "descending" ? i(t.IconSortDescending, { attrs: { size: 20 } }) : i("span", { staticStyle: { width: "44px" } })];
  }, proxy: !0 }]) }, [e._v(" " + e._s(t.t("Name")) + " ")])], 1)]), i("th", { staticClass: "row-size", attrs: { "aria-sort": t.sortBySize } }, [i(t.NcButton, { attrs: { wide: !0, type: "tertiary" }, on: { click: function(n) {
    return t.toggleSorting("size");
  } }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t.sortBySize === "ascending" ? i(t.IconSortAscending, { attrs: { size: 20 } }) : t.sortBySize === "descending" ? i(t.IconSortDescending, { attrs: { size: 20 } }) : i("span", { staticStyle: { width: "44px" } })];
  }, proxy: !0 }]) }, [e._v(" " + e._s(t.t("Size")) + " ")])], 1), i("th", { staticClass: "row-modified", attrs: { "aria-sort": t.sortByModified } }, [i(t.NcButton, { attrs: { wide: !0, type: "tertiary" }, on: { click: function(n) {
    return t.toggleSorting("mtime");
  } }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [t.sortByModified === "ascending" ? i(t.IconSortAscending, { attrs: { size: 20 } }) : t.sortByModified === "descending" ? i(t.IconSortDescending, { attrs: { size: 20 } }) : i("span", { staticStyle: { width: "44px" } })];
  }, proxy: !0 }]) }, [e._v(" " + e._s(t.t("Modified")) + " ")])], 1)])]), i("tbody", [e.loading ? e._l(t.skeletonNumber, function(n) {
    return i(t.LoadingTableRow, { key: n, attrs: { "show-checkbox": e.multiselect } });
  }) : e._l(t.sortedFiles, function(n) {
    return i(t.FileListRow, { key: n.fileid || n.path, attrs: { "allow-pick-directory": e.allowPickDirectory, "show-checkbox": e.multiselect, "can-pick": e.multiselect || e.selectedFiles.length === 0 || e.selectedFiles.includes(n), selected: e.selectedFiles.includes(n), node: n, "crop-image-previews": t.cropImagePreviews }, on: { "update:selected": function(l) {
      return t.onNodeSelected(n);
    }, "enter-directory": t.onChangeDirectory } });
  })], 2)])]);
}, vt = [], mt = /* @__PURE__ */ k(
  ft,
  pt,
  vt,
  !1,
  null,
  "4297db37",
  null,
  null
);
const gt = mt.exports, ht = {
  name: "HomeIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var yt = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon home-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M10,20V14H14V20H19V12H22L12,3L2,12H5V20H10Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, wt = [], Ct = /* @__PURE__ */ k(
  ht,
  yt,
  wt,
  !1,
  null,
  null,
  null,
  null
);
const bt = Ct.exports, kt = {
  name: "PlusIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Ft = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon plus-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, St = [], $t = /* @__PURE__ */ k(
  kt,
  Ft,
  St,
  !1,
  null,
  null,
  null,
  null
);
const xt = $t.exports, Nt = /* @__PURE__ */ I({
  __name: "FilePickerBreadcrumbs",
  props: {
    path: null,
    showMenu: { type: Boolean }
  },
  emits: ["update:path", "create-node"],
  setup(s, { emit: e }) {
    const i = s, t = y(""), n = y();
    function l() {
      var r, u, p, C;
      const f = t.value.trim(), g = (u = (r = n.value) == null ? void 0 : r.$el) == null ? void 0 : u.querySelector("input");
      let d = "";
      return f.length === 0 ? d = w("Folder name cannot be empty.") : f.includes("/") ? d = w('"/" is not allowed inside a folder name.') : ["..", "."].includes(f) ? d = w('"{name}" is an invalid folder name.', { name: f }) : (p = window.OC.config) != null && p.blacklist_files_regex && f.match((C = window.OC.config) == null ? void 0 : C.blacklist_files_regex) && (d = w('"{name}" is not an allowed folder name', { name: f })), g && g.setCustomValidity(d), d === "";
    }
    const o = function() {
      const r = t.value.trim();
      l() && (e("create-node", r), t.value = "");
    }, _ = v(
      () => i.path.split("/").filter((r) => r !== "").map((r, u, p) => ({
        name: r,
        path: "/" + p.slice(0, u + 1).join("/")
      }))
    );
    return { __sfc: !0, props: i, emit: e, newNodeName: t, nameInput: n, validateInput: l, onSubmit: o, pathElements: _, IconFolder: A, IconHome: bt, IconPlus: xt, NcActions: we, NcActionInput: Ce, NcBreadcrumbs: be, NcBreadcrumb: ke, t: w };
  }
});
var Pt = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i(t.NcBreadcrumbs, { staticClass: "file-picker__breadcrumbs", scopedSlots: e._u([{ key: "default", fn: function() {
    return [i(t.NcBreadcrumb, { attrs: { name: t.t("Home"), title: t.t("Home") }, on: { click: function(n) {
      return t.emit("update:path", "/");
    } }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [i(t.IconHome, { attrs: { size: 20 } })];
    }, proxy: !0 }]) }), e._l(t.pathElements, function(n) {
      return i(t.NcBreadcrumb, { key: n.path, attrs: { name: n.name, title: n.path }, on: { click: function(l) {
        return t.emit("update:path", n.path);
      } } });
    })];
  }, proxy: !0 }, e.showMenu ? { key: "actions", fn: function() {
    return [i(t.NcActions, { attrs: { "aria-label": t.t("Create directory"), "force-menu": !0, "force-name": !0, "menu-name": t.t("New"), type: "secondary" }, on: { close: function(n) {
      t.newNodeName = "";
    } }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [i(t.IconPlus, { attrs: { size: 20 } })];
    }, proxy: !0 }], null, !1, 2971667417) }, [i(t.NcActionInput, { ref: "nameInput", attrs: { value: t.newNodeName, label: t.t("New folder"), placeholder: t.t("New folder name") }, on: { "update:value": function(n) {
      t.newNodeName = n;
    }, submit: t.onSubmit, input: t.validateInput }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [i(t.IconFolder, { attrs: { size: 20 } })];
    }, proxy: !0 }], null, !1, 1614167509) })], 1)];
  }, proxy: !0 } : null], null, !0) });
}, Lt = [], zt = /* @__PURE__ */ k(
  Nt,
  Pt,
  Lt,
  !1,
  null,
  "3bc9efa5",
  null,
  null
);
const Bt = zt.exports, It = {
  name: "ClockIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Vt = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon clock-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, Rt = [], Mt = /* @__PURE__ */ k(
  It,
  Vt,
  Rt,
  !1,
  null,
  null,
  null,
  null
);
const Dt = Mt.exports, Ht = {
  name: "CloseIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var At = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon close-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, Tt = [], Et = /* @__PURE__ */ k(
  Ht,
  At,
  Tt,
  !1,
  null,
  null,
  null,
  null
);
const Ut = Et.exports, Zt = {
  name: "MagnifyIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Ot = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon magnify-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M9.5,3A6.5,6.5 0 0,1 16,9.5C16,11.11 15.41,12.59 14.44,13.73L14.71,14H15.5L20.5,19L19,20.5L14,15.5V14.71L13.73,14.44C12.59,15.41 11.11,16 9.5,16A6.5,6.5 0 0,1 3,9.5A6.5,6.5 0 0,1 9.5,3M9.5,5C7,5 5,7 5,9.5C5,12 7,14 9.5,14C12,14 14,12 14,9.5C14,7 12,5 9.5,5Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, jt = [], Gt = /* @__PURE__ */ k(
  Zt,
  Ot,
  jt,
  !1,
  null,
  null,
  null,
  null
);
const Wt = Gt.exports, qt = {
  name: "StarIcon",
  emits: ["click"],
  props: {
    title: {
      type: String
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
};
var Kt = function() {
  var e = this, i = e._self._c;
  return i("span", e._b({ staticClass: "material-design-icon star-icon", attrs: { "aria-hidden": !e.title, "aria-label": e.title, role: "img" }, on: { click: function(t) {
    return e.$emit("click", t);
  } } }, "span", e.$attrs, !1), [i("svg", { staticClass: "material-design-icon__svg", attrs: { fill: e.fillColor, width: e.size, height: e.size, viewBox: "0 0 24 24" } }, [i("path", { attrs: { d: "M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z" } }, [e.title ? i("title", [e._v(e._s(e.title))]) : e._e()])])]);
}, Xt = [], Jt = /* @__PURE__ */ k(
  qt,
  Kt,
  Xt,
  !1,
  null,
  null,
  null,
  null
);
const Qt = Jt.exports, Yt = /* @__PURE__ */ I({
  __name: "FilePickerNavigation",
  props: {
    currentView: null,
    filterString: null,
    isCollapsed: { type: Boolean }
  },
  emits: ["update:currentView", "update:filterString"],
  setup(s, { emit: e }) {
    const i = s, t = [{
      id: "files",
      label: w("All files"),
      icon: A
    }, {
      id: "recent",
      label: w("Recent"),
      icon: Dt
    }, {
      id: "favorites",
      label: w("Favorites"),
      icon: Qt
    }], n = v(() => t.filter((o) => o.id === i.currentView)[0]);
    return { __sfc: !0, allViews: t, props: i, emit: e, currentViewObject: n, updateFilterValue: (o) => e("update:filterString", o), IconClose: Ut, IconMagnify: Wt, NcButton: ne, NcSelect: Fe, NcTextField: Se, t: w, Fragment: Pe };
  }
});
var ei = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i(t.Fragment, [i(t.NcTextField, { staticClass: "file-picker__filter-input", attrs: { value: e.filterString, label: t.t("Filter file list"), "show-trailing-button": !!e.filterString }, on: { "update:value": t.updateFilterValue, "trailing-button-click": function(n) {
    return t.updateFilterValue("");
  } }, scopedSlots: e._u([{ key: "trailing-button-icon", fn: function() {
    return [i(t.IconClose, { attrs: { size: 16 } })];
  }, proxy: !0 }]) }, [i(t.IconMagnify, { attrs: { size: 16 } })], 1), e.isCollapsed ? i(t.NcSelect, { attrs: { "aria-label": t.t("Current view selector"), clearable: !1, searchable: !1, options: t.allViews, value: t.currentViewObject }, on: { input: (n) => t.emit("update:currentView", n.id) } }) : i("ul", { staticClass: "file-picker__side", attrs: { role: "tablist", "aria-label": t.t("Filepicker sections") } }, e._l(t.allViews, function(n) {
    return i("li", { key: n.id }, [i(t.NcButton, { attrs: { "aria-selected": e.currentView === n.id, type: e.currentView === n.id ? "primary" : "tertiary", wide: !0, role: "tab" }, on: { click: function(l) {
      return e.$emit("update:currentView", n.id);
    } }, scopedSlots: e._u([{ key: "icon", fn: function() {
      return [i(n.icon, { tag: "component", attrs: { size: 20 } })];
    }, proxy: !0 }], null, !0) }, [e._v(" " + e._s(n.label) + " ")])], 1);
  }), 0)], 1);
}, ti = [], ii = /* @__PURE__ */ k(
  Yt,
  ei,
  ti,
  !1,
  null,
  "fcfd0f23",
  null,
  null
);
const ni = ii.exports;
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const li = function(s, e) {
  const i = pe(), t = y([]), n = y(!0);
  async function l(_, r = D) {
    const u = await i.stat("".concat(r).concat(_), {
      details: !0
    });
    return M(u.data);
  }
  async function o() {
    if (n.value = !0, s.value === "favorites")
      t.value = await ve(i, e.value);
    else if (s.value === "recent") {
      const _ = Math.round(Date.now() / 1e3) - 1209600, { data: r } = await i.search("/", {
        details: !0,
        data: me(_)
      });
      t.value = r.results.map((u) => M(u));
    } else {
      const _ = await i.getDirectoryContents("".concat(D).concat(e.value), {
        details: !0,
        data: ge()
      });
      t.value = _.data.map((r) => M(r));
    }
    n.value = !1;
  }
  return te([s, e], () => o()), R(() => o()), {
    isLoading: n,
    files: t,
    loadFiles: o,
    getFile: l,
    client: i
  };
};
/**
 * @copyright Copyright (c) 2023 Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @author Ferdinand Thiessen <opensource@fthiessen.de>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
const si = function(s) {
  const e = v(() => s.value.map((t) => t.split("/")));
  return {
    isSupportedMimeType: (t) => {
      const n = t.split("/");
      return e.value.some(
        ([l, o]) => (
          // check mime type matches or is wildcard
          (n[0] === l || l === "*") && (n[1] === o || o === "*")
        )
      );
    }
  };
}, ri = {
  name: "FilePicker"
}, ai = /* @__PURE__ */ I({
  ...ri,
  props: {
    buttons: null,
    name: null,
    allowPickDirectory: { type: Boolean, default: !1 },
    container: { default: "body" },
    filterFn: { default: void 0 },
    mimetypeFilter: { default: () => [] },
    multiselect: { type: Boolean, default: !0 },
    path: { default: "/" }
  },
  emits: ["close"],
  setup(s, { emit: e }) {
    const i = s, t = v(() => ({
      container: i.container,
      name: i.name,
      buttons: n.value,
      size: "large",
      contentClasses: ["file-picker__content"],
      dialogClasses: ["file-picker"],
      navigationClasses: ["file-picker__navigation"]
    })), n = v(() => (typeof i.buttons == "function" ? i.buttons(_.value, p.value, l.value) : i.buttons).map((c) => ({
      ...c,
      callback: async () => {
        const F = _.value.length === 0 && i.allowPickDirectory ? [await $(p.value)] : _.value;
        c.callback(F), e("close", F);
      }
    }))), l = y("files"), o = v(() => l.value === "favorites" ? w("Favorites") : l.value === "recent" ? w("Recent") : ""), _ = y([]), r = y((window == null ? void 0 : window.sessionStorage.getItem("NC.FilePicker.LastPath")) || "/"), u = y(), p = v({
      // Only use the path for the files view as favorites and recent only works on the root
      get: () => l.value === "files" ? u.value || i.path || r.value : "/",
      /**
       * Navigate to the new path and save it to the session storage
       *
       * @param path The new path
       */
      set: (a) => {
        i.path === void 0 && window.sessionStorage.setItem("NC.FilePicker.LastPath", a), u.value = a, _.value = [];
      }
    }), C = y(""), { isSupportedMimeType: f } = si(_e(i, "mimetypeFilter")), { files: g, isLoading: d, loadFiles: S, getFile: $, client: P } = li(l, p);
    R(() => S());
    const { showHiddenFiles: N } = oe(), L = v(() => {
      let a = g.value;
      return N.value || (a = a.filter((c) => !c.basename.startsWith("."))), i.mimetypeFilter.length > 0 && (a = a.filter((c) => c.type === "folder" || c.mime && f(c.mime))), C.value && (a = a.filter((c) => c.basename.toLowerCase().includes(C.value.toLowerCase()))), i.filterFn && (a = a.filter((c) => i.filterFn(c))), a;
    }), m = v(() => l.value === "files" ? w("Upload some content or sync with your devices!") : l.value === "recent" ? w("Files and folders you recently modified will show up here.") : w("Files and folders you mark as favorite will show up here."));
    return { __sfc: !0, props: i, emit: e, dialogProps: t, dialogButtons: n, currentView: l, viewHeadline: o, selectedFiles: _, savedPath: r, navigatedPath: u, currentPath: p, filterString: C, isSupportedMimeType: f, files: g, isLoading: d, loadFiles: S, getFile: $, client: P, showHiddenFiles: N, filteredFiles: L, noFilesDescription: m, onCreateFolder: async (a) => {
      try {
        await P.createDirectory(le(D, p.value, a)), await S(), Le("files:node:created", g.value.filter((c) => c.basename === a)[0]);
      } catch (c) {
        console.warn("Could not create new folder", { name: a, error: c }), Ne(w("Could not create the new folder"));
      }
    }, handleClose: (a) => {
      a || e("close");
    }, IconFile: ae, FileList: gt, FilePickerBreadcrumbs: Bt, FilePickerNavigation: ni, NcDialog: $e, NcEmptyContent: xe, t: w };
  }
});
var oi = function() {
  var e = this, i = e._self._c, t = e._self._setupProxy;
  return i(t.NcDialog, e._b({ on: { "update:open": t.handleClose }, scopedSlots: e._u([{ key: "navigation", fn: function({ isCollapsed: n }) {
    return [i(t.FilePickerNavigation, { attrs: { "is-collapsed": n, "current-view": t.currentView, "filter-string": t.filterString }, on: { "update:currentView": function(l) {
      t.currentView = l;
    }, "update:current-view": function(l) {
      t.currentView = l;
    }, "update:filterString": function(l) {
      t.filterString = l;
    }, "update:filter-string": function(l) {
      t.filterString = l;
    } } })];
  } }]) }, "NcDialog", t.dialogProps, !1), [i("div", { staticClass: "file-picker__main" }, [t.currentView === "files" ? i(t.FilePickerBreadcrumbs, { attrs: { path: t.currentPath, "show-menu": e.allowPickDirectory }, on: { "update:path": function(n) {
    t.currentPath = n;
  }, "create-node": t.onCreateFolder } }) : i("div", { staticClass: "file-picker__view" }, [i("h3", [e._v(e._s(t.viewHeadline))])]), t.isLoading || t.filteredFiles.length > 0 ? i(t.FileList, { attrs: { "allow-pick-directory": e.allowPickDirectory, "current-view": t.currentView, files: t.filteredFiles, multiselect: e.multiselect, loading: t.isLoading, path: t.currentPath, "selected-files": t.selectedFiles, name: t.viewHeadline }, on: { "update:path": [function(n) {
    t.currentPath = n;
  }, function(n) {
    t.currentView = "files";
  }], "update:selectedFiles": function(n) {
    t.selectedFiles = n;
  }, "update:selected-files": function(n) {
    t.selectedFiles = n;
  } } }) : t.filterString ? i(t.NcEmptyContent, { attrs: { name: t.t("No matching files"), description: t.t("No files matching your filter were found.") }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [i(t.IconFile)];
  }, proxy: !0 }]) }) : i(t.NcEmptyContent, { attrs: { name: t.t("No files in here"), description: t.noFilesDescription }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [i(t.IconFile)];
  }, proxy: !0 }]) })], 1)]);
}, ci = [], ui = /* @__PURE__ */ k(
  ai,
  oi,
  ci,
  !1,
  null,
  "86a13079",
  null,
  null
);
const ki = ui.exports;
export {
  ki as default
};
